import React from 'react';
import styles from './terms&policy.module.css';
import CustomSeparator from '../../components/maincomps/breadcrumbs/Breadcrumbs';
import breadcrumbStyle from '../../components/maincomps/breadcrumbs/breadcrumbs.module.css';

const ShippingPolicy = () => {
    return (
        <>
        <div className={breadcrumbStyle.breadcrumbStyle}>
                <CustomSeparator home="Home" type="Shipping Policy" />
            </div>
            <div className={styles.container}>
                <h2>Shipping Policy</h2>

                <div className={styles.containermain}>
                    <p>
                        This Privacy Policy describes our policies and procedures on the
                        collection, use, and disclosure of your information when you use the
                        Service and tells you about your privacy rights and how the law
                        protects you.
                    </p>
                    <p>
                        We use your personal data to provide and improve the Service. By using
                        the Service, you agree to the collection and use of information in
                        accordance with this Privacy Policy.
                    </p>

                    <h3>Company Information</h3>
                    <p>
                        Company owns, operates, and maintains the website{' '}
                        <a href="https://www.pavitra.in" target="_blank" rel="noopener noreferrer">
                            https://www.pavitra.in
                        </a>{' '}
                        (“Company website” / “Platform”). The Company offers curetted and
                        specially designed higher education and industry-relevant certification
                        programs online (“Programs”). In order to deliver the Programs
                        efficiently and make available the website, the Company collects
                        certain information regarding the Client/User. The Company values the
                        trust placed by Users, and therefore, follows the highest standards to
                        protect the Client's Personal Information.
                    </p>

                    <p>
                        This Privacy Policy (“Privacy Policy”) describes how the Company
                        collects, uses, updates, deletes, and shares information about the
                        Company's users (hereinafter referred to as “User”) through the
                        Company's Platform. This Privacy Policy shall form a part of the Terms
                        by way of reference. All capitalized terms not defined in this Privacy
                        Policy have the respective meanings outlined in the Terms of Use. This
                        Privacy Policy applies only to the part of the Platform provided by the
                        Company. The Company is not responsible for the practices of persons,
                        companies, institutions, or websites that Kingster Education does not
                        control, manage, or employ.
                    </p>

                    <p>
                        User shall mean and include any person/persons who visit, use, deal
                        with, and transact through the website and have a guest user and
                        browser. In circumstances where the User is less than 18 years of age,
                        consent from the legal guardian shall be required, and it is advised
                        that this Policy be read in the presence of the legal guardian.
                    </p>

                    <p>
                        The Company takes care and performs due diligence to ensure the privacy
                        aspects of every individual who interacts with the Company's Platform,
                        by design and by default, in alignment with all applicable laws and
                        regulations.
                    </p>

                    <p>
                        Please understand that by using the Company's Platform or submitting
                        any Personally Identifiable Information (defined below) to the Company,
                        the User consents and agrees that the Company may collect, use, update,
                        disclose, and retain the User's information (including but not limited
                        to Personally Identifiable Information) following this Privacy Policy,
                        and as permitted or required by law. Kingster Education reserves the
                        right to share the information collected hereunder with its affiliates.
                        In the event of the sale or transfer of all or a portion of the
                        Company's business assets, consumer information may be one of the
                        business assets transferred as part of the transaction. If the User
                        does not agree with these Terms, please do not provide any Personally
                        Identifiable Information to Kingster. If the User refuses or withdraws
                        consent, or if the User chooses not to provide the Company with any
                        required Personally Identifiable Information, the Company may not
                        provide the User with the services that can be offered on the Company's
                        Platform.
                    </p>

                    <p>
                        This Policy has been drafted in accordance with the applicable data
                        protection laws, rules, and regulations including but not limited to
                        the General Data Protection Regulation, 2018 (“GDPR”), the Information
                        Technology Act, 2000 (“IT Act”), and the Information Technology
                        (Reasonable Security Practices and Procedures and Sensitive Personal
                        Data or Information) Rules, 2011 (“IT Rules”), collectively referred to
                        as “Data Protection Laws.”
                    </p>
                </div>
            </div>
        </>
    );
};

export default ShippingPolicy;
